export const iconSize = "4ch"
export const iconColor = "white"
export const headerIconColor = "black"